import { SidebarComponent } from '../sidebar/sidebar.component';
import { HeaderComponent } from '../header/header.component';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';

import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    SidebarComponent,
    HeaderComponent
],
  template: `
    <div class="dash">
      <!-- Sidebar fixe sans mat-sidenav -->
      <aside [class.collapsed]="!isSidebarOpen">
        <app-sidebar [isOpen]="isSidebarOpen"></app-sidebar>
      </aside>

      <!-- Contenu principal -->
      <div class="main-wrapper" [class.sidebar-collapsed]="!isSidebarOpen">
        <app-header (toggleSidebar)="toggleSidebar()"></app-header>

        <main class="content-area">
          <router-outlet></router-outlet>
        </main>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: []
})
export class MainLayoutComponent {
  isSidebarOpen = false;

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
}
